import { base64 } from '../utils/index'
const state = {
  /**
   * ========================================================
   * ************   公共部分   ************
   * ========================================================
   */
  // 用户信息
  userInfo: localStorage.getItem('I') ? JSON.parse(base64.decode(localStorage.getItem('I'))) : '',
  // 用户角色信息
  // userRole: localStorage.getItem('I')  ? JSON.parse(base64.decode(localStorage.getItem('I') )) : '',
  // 顶部导航文字
  navigateTitle: '',
  // 底部tab选中状态
  tabAcion: 0,
  // 顶部menu弹出控制
  menuShow: false,
  // 顶部menuList
  menuList: [],
  // 当前选中menu
  currentMenu: '',
  // 存款是否新版本
  isNewDeposit: true,
  /**
   * ========================================================
   * ************   account-info   ************
   * ========================================================
   */

  // 储存提交银行信息
  // bankInfo: {
  //   country: {},
  //   selectBank: '',
  //   cardNumber: '',
  //   branchName: '',
  // }
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js